<template>
  <div class="zcbody">
    <div class="zc-header">
      <div class="head" style="padding: 20px 0 30px 0;">
        <div class="logo">
          <router-link :to="{path:'/login'}"><img src="../../assets/images/logo.png" style="width:80px" /></router-link>
        </div>
        <span class="logintext">认养一头牛SRM供应商管理平台&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </div>
    </div>
    <div class="contaner">
      <div class="z_heng">
        <ul>
          <li class="agreement active"><img src="../../assets/images/agreement1.png"><span>注册协议</span></li>
          <li class="information"><img src="../../assets/images/information1.png"><span>用户信息</span></li>
          <li class="archives"><img src="../../assets/images/archives1.png"><span>供货信息</span></li>
          <li class="supply-object"><img src="../../assets/images/supply-object1.png"><span>上传资质</span></li>
          <li class="intelligence"><img src="../../assets/images/intelligence1.png"><span>注册完成</span></li>
        </ul>
      </div>
      <div class="protocol-title">供应商行为准则</div>
      <div class="protocol-content" style="height:600px">
        <div id="protocol-content">
          <h1>供应商行为准则</h1>
          认养一头牛牧场在与各供应单位从事商业活动中坚定地执行崇高的商业道德准则、严格的安全生产准则以及规范的采购平台系统使用准则。
          <br>
          <br>
          一、商业道德准则<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、认养一头牛牧场及其所有工作人员不接受来自于供应商的宴请招待、促销奖励、礼品等。我们所有的采购决策将根据采购价格和产品、服务的质量而定。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、认养一头牛牧场实施了严格的公司反腐规定约束我们所有的工作人员。这些制度禁止我们的员工：1)接受礼品、招待；2)收受现金；3)接受价值500元以上的促销奖励；4)接受供应商付费的旅行或参加供应商付费的没有明确商务议题或过度的娱乐活动。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、认养一头牛牧场一旦发现供应商故意违反以上规定的行为，认养一头牛牧场将终止与该供应商的商务关系。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、供应商应按时核对账目，开具并提供合法正规发票。若供应商存在提供假发票、使用他人发票或开具发票后未征得我公司同意私自作废发票的行为，一经发现，我公司将停止支付所有剩余应付款项，并追究其法律责任。同时我公司会将该类供应商永久性记入黑名单不再合作。<br>
          <br>
          二、安全生产准则<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、认养一头牛牧场所购货物成交方式均为牧场交货，即在交货前供应商应承担货物运输中的所有风险，包括相关人员的人身安全。出现任何问题，均应由供应商自行负责。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、供应商派遣司机进入认养一头牛牧场时应严格遵守各牧场的管理规定，如入场登记、更换隔离服、禁止抽烟等。因供应商所派遣司机不遵守认养一头牛牧场的管理规定所造成的一切后果及责任均由供应商自行承担。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、供应商所派遣司机在卸货过程中的职责为：解开缆绳，掀开篷布，打开车厢门以及卸货完成后的收尾工作。收尾工作包括缆绳和篷布回收，车厢门关闭等。供应商所派遣司机进行上述操作时应注意安全，遵守自身安全操作规程并自行承担安全责任，若发生人员伤亡及货物损失的，一切责任均应由供应商承担。<br>
          供应商所派遣司机及随车人员不得参与认养一头牛牧场装卸工作，否则由此发生的事故责任应由供应商承担。若供应商派遣司机及随车人员自行登高作业，应谨慎、小心，防止高空坠落或高空坠物砸伤，否则由此带来的一切风险责任均应由供应商自行承担。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、供应商所派遣司机应服从牧场相关工作人员指挥，若司机辱骂或殴打牧场相关人员，由此造成的后果及损失均应由供应商承担。如查证属实，视情节轻重给予供应商5000-10000元人民币罚款。触犯法律的，移交公安机关依法处理。<br>
          <br>
          三、采购平台系统使用准则<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;所有认养一头牛牧场的供应商均须遵守认养一头牛牧场采购平台系统使用规范，具体要求如下：<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(一)饲料类供应商采购平台系统使用规范<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、供应商注册平台账号时，应按照系统提示详细、准确、完整的填写公司基本信息、银行账号及业务人员信息等。银行账号将作为后期汇款账号，业务人员发生变更的(联系人、电话、银行账号、地址)应及时在平台更新信息。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、供应商应严格按照认养一头牛牧场采购平台系统规定时间进行报价。超出报价时间的，默认该供应商自行放弃本次报价资格。若供应商连续三次出现未报价的，系统将自动停止该供应商未报价物料的报价资格三个月。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、供应商报价上传系统成功后即视为报价生效，在报价有效期内，认养一头牛牧场有权根据供应商报价与其确定合同意向并签订合同。若供应商连续五次推送报价成功后无成交的，系统将自动停止该供应商未成交物料的报价资格一年。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、供应商报价成功并确认成交后，若因市场行情变化等因素拒不接单不签订合同的，该供应商以及该供应商企业法人名下的所有合作公司将会被永久性记入黑名单并报公司领导审批。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(二)非饲料类供应商采购平台系统使用规范<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、供应商注册平台账号时，应按照系统提示详细、准确、完整的填写公司基本信息、银行账号及业务人员信息等。业务人员发生变更的(联系人、电话、地址)应及时在平台更新信息。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、供应商应严格按照认养一头牛牧场采购平台系统规定时间进行报价。超出报价时间的，默认该供应商自行放弃本次报价资格。若供应商连续三次出现未报价的，系统将自动停止该供应商未报价物料所属类别物品的报价资格三个月。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、供应商报价上传系统成功后即视为报价生效，在报价有效期内，认养一头牛牧场有权根据供应商报价与其确定合同意向并签订合同。若供应商连续五次推送报价成功后无成交的，系统将自动停止该供应商未成交物料所属类别的物品报价资格一年。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、对于框架合同、分次采购或线上报价、议价成交的物料，若供应商连续三次未按时确认订单或价格的，认养一头牛牧场采购•贸易中心将重新确认合作供应商。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、供应商报价成功并确认成交后，若因市场行情变化等因素拒不接单不签订合同的，该供应商以及该供应商企业法人名下的所有合作公司将会被永久性记入黑名单并报公司领导审批。<br>

          <br>
          四、其他<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;认养一头牛牧场有权根据公司发展情况及相关管理制度增加、删除或更新以上准则。作为认养一头牛牧场的供应商，请您确认已熟知并将严格遵守以上规定。<br>
          <br>
          <br>
        </div>

      </div>
      <div class="protocol-accept">
        <label class="checkbox" for="cb">
          <el-checkbox @change="handleCheckChange" :disabled="ifdisabled">{{textimer}}</el-checkbox>

        </label>
        <div class="submit">
          <input type="submit" :style="'background-color:'+bgcolor" name="submit1" value="下一步" id="tj" :disabled="nxtdisabled" @click="next">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: 5,
      textimer: "",
      ifdisabled: true,
      bgcolor: "#d0d2d1",
      nxtdisabled: true,
    };
  },
  methods: {
    handleCheckChange(val) {
      if (val == true) {
        this.nxtdisabled = false;
        // 如果同意协议，为绿色
        this.bgcolor = "#36bfa0";
      } else {
        this.nxtdisabled = true;
        this.bgcolor = "#d0d2d1";
      }
    },
    countDown() {
      let THIS = this;
      THIS.time--;

      if (THIS.time > 0) {
        THIS.textimer =
          "请仔细阅读《用户注册协议》还剩下【" + THIS.time + "】秒";
      }
      if (THIS.time == 0) {
        this.textimer = "我已阅读并接受";
        this.ifdisabled = false;
        clearInterval(THIS.countDown);
      }
    },
    next() {
      this.$router.push("/useregister");
    },
  },
  mounted() {
    setInterval(this.countDown, 1000);
  },
};
</script>
<style scoped>
@import url(../../assets/css/reg.css);
</style>